export const globalToast = {
  data() {
    return {
      timer: null
    };
  },
  watch: {
    "$store.getters.toastShow": {
      deep: true,
      handler: function (toastShow) {
        if (toastShow.show) {
          this.setToastShow(
            toastShow.content.txt,
            toastShow.content.type,
            toastShow.content.time
          );
          let time = toastShow.content.time || 3000;
          this.timer = setTimeout(() => {
            this.setToastHide(
              toastShow.content.txt,
              toastShow.content.type,
              toastShow.content.time
            );
          }, time);
        } else {
          clearTimeout(this.timer)
        }
      }
    }
  },
  methods: {
    setToastShow(txt, type = "txt", time = 3000) {
      this.$createToast({
        txt: txt,
        type: type,
        time: time
      }).show();
    },
    setToastHide(txt, type = "txt", time = 3000) {
      this.$createToast({
        txt: txt,
        type: type,
        time: time
      }).hide();
      this.$store.commit("setToastShow", {
        show: false,
        content: {}
      });
    }
  }
}